/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

/**
 * Retrieves the current locale
 * @returns current locale
 */
export function getLocale() {
  // TODO: fully implement Config.getLocale
  return 'en';
}
